module.exports = __webpack_public_path__ + "img/rightCenter.98395b44.png";